module.exports = __webpack_public_path__ + "img/ai11.8efa2a49.png";